import styled from 'styled-components';
import {
  brand,
  breakpoints,
  ink,
  surface,
  tones,
  textSize,
} from '../../../styles/brand';

const GAP = '0.2rem';

export const Track = styled.div<{ $count: number }>`
  position: relative;
  display: grid;
  grid-template-columns: repeat(${({ $count }) => $count}, minmax(0, 1fr));
  padding: ${GAP};
  border-radius: 0.75rem;
  background: ${surface.line};
  width: 100%;
  max-width: 26rem;
`;

export const Thumb = styled.span<{ $count: number; $index: number }>`
  position: absolute;
  top: ${GAP};
  bottom: ${GAP};
  left: ${GAP};
  width: calc((100% - 2 * ${GAP}) / ${({ $count }) => $count});
  border-radius: 0.55rem;
  background: ${brand.white};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  transform: translateX(${({ $index }) => $index * 100}%);
  transition: transform 320ms cubic-bezier(0.32, 0.72, 0, 1);

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const Button = styled.button`
  position: relative;
  z-index: 1;
  min-height: 2.5rem;
  padding: 0 0.75rem;
  border: 0;
  border-radius: 0.55rem;
  background: transparent;
  font-family: 'RedHatDisplay-Bold';
  font-size: ${textSize(0.9)};
  color: ${tones.gray.text};
  cursor: pointer;
  touch-action: manipulation;
  transition: color 160ms ease;
  /* Coluna estreita no celular: o rótulo longo não pode vazar do trilho. */
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: ${breakpoints.md}) {
    padding: 0 0.35rem;
    font-size: ${textSize(0.82)};
  }

  &[aria-selected='true'] {
    color: ${ink};
  }

  &:focus-visible {
    outline: 2px solid ${brand.blue};
    outline-offset: 2px;
  }
`;
